module.exports = "/_next/static/images/6df39601cd9599d5a56f4e52e0ecd868-heart-emoji.jpeg.webp";